// frontend/src/pages/About.jsx
import React from 'react';
import LegalLayout from './legal/LegalLayout';

const About = () => (
  <LegalLayout title="About DrivenBy Bus" lastUpdated="22 September 2026">
    <h2>What we build</h2>
    <p>
      DrivenBy Bus is a live public transit operations and intelligence platform for bus
      networks. We turn open transit data into operational tools that help operators,
      planners, and analysts see what is actually happening on the road — not just what
      the timetable says should be happening.
    </p>

    <h2>Who it’s for</h2>
    <ul>
      <li><strong>Operators</strong> — monitor live headways, punctuality and vehicle allocation across a route in real time.</li>
      <li><strong>Planners</strong> — review arrival performance and identify pinch points across the day.</li>
      <li><strong>Analysts</strong> — export and interrogate schedule-versus-live performance by stop, trip and hour.</li>
    </ul>

    <h2>Data</h2>
    <p>
      All vehicle location data we display is derived from public transit feeds published
      under the Open Government Licence v3.0. DrivenBy Bus is not affiliated with, or
      endorsed by, Transport for London.
    </p>

    <h2>Contact</h2>
    <p>
      General enquiries: <a href="mailto:info@drivenby.com.hk">info@drivenby.com.hk</a>
      <br />
      Privacy &amp; data requests: <a href="mailto:privacy@drivenby.com">privacy@drivenby.com</a>
    </p>
  </LegalLayout>
);

export default About;